import { AspectRatio, Box, Flex, Stack } from '@chakra-ui/react';
import LeftArrow from '@components/icons/LeftArrow';
import ShareButtons from '@components/interactive/ShareButtons';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import useSSRDate from '@hooks/useSSRDate';
import Image from 'next/image';

const ArticleHeading = ({
  title,
  imageSrc,
  imageAlt,
  dateString,
  backHref,
  author = 'Daniel Petkevich',
  videoSrc = null,
}) => {
  const { formattedDate } = useSSRDate(dateString);
  return (
    <Stack alignItems="center">
      <Flex w="100%" justify="center" paddingBottom="40px" gap={[2, 2, 4, 10]}>
        <Box>
          <LeftArrow href={backHref} />
        </Box>
        <Header as="h2" maxW="800px" textAlign="center" mt="-6px" mx="auto">
          {title}
        </Header>
      </Flex>
      <Box w="100%">
        {videoSrc ? (
          <Box w={['100%', 'calc(100%)', 'calc(100% - 120px)']} h={['240px', '300px', '320px']} mx="auto">
            <iframe title="naruto" src={videoSrc} width="100%" height="100%" style={{ display: 'block' }} />
          </Box>
        ) : (
          <Flex w="100%" justifyContent="center">
            <AspectRatio shadow="lg" borderRadius={10} overflow="hidden" w="100%" maxH={300}>
              <Image src={imageSrc} alt={imageAlt || 'Article Heading Image'} width={830} height={300} priority />
            </AspectRatio>
          </Flex>
        )}
      </Box>
      <Box
        w="100%"
        pt={7}
        pb={6}
        maxW="840px"
        alignItems="left"
        // This centers mid-article photo captions
        sx={{
          '.chakra-aspect-ratio + p': {
            textAlign: 'center',
          },
        }}
      >
        <Box display="flex" width="100%" flexDirection={['column', 'column', 'row']} gap={4}>
          <Stack width="100%" spacing={0}>
            <Body1>By {author}</Body1>
            <Body1>{formattedDate}</Body1>
          </Stack>
          <ShareButtons
            href={typeof window !== 'undefined' ? window.location.href.split('?')[0] : process.env.BASE_URL}
          />
        </Box>
      </Box>
    </Stack>
  );
};

export default ArticleHeading;
